let w_lang,
    w_resizeTimer;

const w_base = '/',
      w_myScreen = {},
      w_myBrowser = {
        engine: '',
        version: 0,
        os: ''
      },
      w_duration = {
        short: 250,
        mid: 500,
        long: 2000
      },
      w_pointer = {};

window.addEventListener('DOMContentLoaded',function()
{
    // get language from HTML
    w_lang = document.documentElement.lang;
    const myGoogleMap = document.getElementById('w--googlemap'),
          mySliders = document.body.querySelectorAll('.w__header,.w__module--slider'),
          myTogglers = document.body.querySelectorAll('.w__toggler.active'),
          myForm = document.getElementById('w--form'),
          myItemSliders = document.body.querySelectorAll('.w__item--container');


    // load polyfills for old browsers
    if(!('Promise' in window))
    {
        const myLibrary = document.createElement('script');
        myLibrary.src = w_base + 'lib/polyfills.es5.js';
        document.head.appendChild(myLibrary);
    }

    // get os, browser engine and version
    get_browser();

    // remove hover from body
    if(w_myBrowser.mobile === true)
    {
        document.body.classList.remove('w__hover');

        if('PointerEvent' in window)
        {
            w_pointer['down'] = 'pointerdown';
            w_pointer['up'] = 'pointerup';
            w_pointer['move'] = 'pointermove';
            w_pointer['checkType'] = true;
        }
        else
        {
            w_pointer['down'] = 'touchstart';
            w_pointer['up'] = 'touchend';
            w_pointer['move'] = 'touchmove';
            w_pointer['checkType'] = false;
        }
    }

    // get screen size
    get_screenSize(true);

    // add event listener
    document.body.addEventListener('click',e =>
    {
        let el = e.target;

        if(el.closest('.w__js-button'))
        {
            el = el.closest('.w__js-button');
        }

        if(el.classList.contains('w__mobile--menu-button'))
        {
            document.body.classList.toggle('w__mobile--menu-active');
        }
        else if(el.classList.contains('w__js-button'))
        {
            switch(el.dataset.f)
            {
                case 'close-lightbox':
                    Lightbox.close();
                    break;

                case 'play-video':
                    e.preventDefault();
                    new Lightbox(el, 'video');
                    break;

                case 'show-news':
                    e.preventDefault();
                    new Lightbox(el, 'news');
                    break;

                case 'toggle-list':
                    const myList = el.nextElementSibling;
                    if(myList && myList.classList.contains('w__ul'))
                    {
                        if(el.classList.contains('active'))
                        {
                            el.classList.remove('active');
                            myList.classList.add('none');
                        }
                        else
                        {
                            el.classList.add('active');
                            myList.classList.remove('none');
                        }
                    }
                    break;

                case 'toggle-news':
                    e.preventDefault();
                    const myNewsList = el.previousElementSibling;
                    if(myNewsList)
                    {
                        el.remove();
                        myNewsList.classList.add('active');
                    }
                    break;

                default:
                    alert("Unbekannte Funktion: " + el.dataset.f);
            }
        }
        else if(w_myScreen.layout !== 'desktop' && el.closest('.w__menu--main'))
        {
            document.body.classList.remove('w__mobile--menu-active');
        }
    });

    // activate sliders
    if(mySliders)
    {
        for(let i=0; i<mySliders.length; i++)
        {
            new Slideshow(mySliders[i]);
        }
    }

    // close togglers
    if(myTogglers)
    {
        for(let i=0; i<myTogglers.length; i++)
        {
            const myList = myTogglers[i].nextElementSibling;
            if(myList && myList.classList.contains('w__ul'))
            {
                myTogglers[i].classList.remove('active');
                myTogglers[i].classList.add('w__js-button');
                myTogglers[i].dataset.f = 'toggle-list';
                myList.classList.add('none');
            }
        }
    }

    // add google map
    if(myGoogleMap)
    {
        load_googlemapApi(myGoogleMap);
    }

    // add form processing
    if(myForm)
    {
        new Form(myForm);
    }

    // add item sliders
    if(myItemSliders)
    {
        for(let i=0; i<myItemSliders.length; i++)
        {
            new ItemSlider(myItemSliders[i]);
        }
    }

    // add automarking of active section
    if('IntersectionObserver' in window)
    {
        add_interactionObserver();
    }
});

const load_googlemapApi = function(parentEl)
{
    const myLibrary = document.createElement('script');
    myLibrary.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA0V3ehMtm77qoHY8nVN3ad5CpNdNfMDEg';
    myLibrary.onload = function()
    {
        build_googlemap(parentEl);
    };
    document.head.appendChild(myLibrary);
}

const build_googlemap = function(parentEl)
{
    parentEl.classList.remove('none');
    const myMapCanvas = document.createElement('div'),
          latLng = {lat: parseFloat(parentEl.dataset.lat), lng: parseFloat(parentEl.dataset.long)},
          markerLatLng = {lat: parseFloat(parentEl.dataset.markerLat), lng: parseFloat(parentEl.dataset.markerLong)},
          zoomLevel = parseInt(parentEl.dataset.zoom);
          myMapCanvas.classList.add('w__googlemap--inner');
    parentEl.appendChild(myMapCanvas);

    const myOptions = {
        zoom: zoomLevel,
        center: latLng,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        zoomControl: true,
        draggable: true,
        styles:
            [{
                featureType: 'all', stylers:
                    [{
                        saturation: -100
                    },
                        {
                            gamma: 0.80
                        }
                    ]},
                {
                    featureType: 'poi', elementType: 'labels', stylers:
                        [{
                            visibility: 'off'
                        }]
                }]
    };
    const map = new google.maps.Map(myMapCanvas, myOptions);
    const marker = new google.maps.Marker(
        {
            position: markerLatLng,
            map: map,
            icon: {url: w_base + 'pix/icon_marker.' + (w_myBrowser.engine === 'trident' ? 'png' : 'svg')}
        });
    map.setOptions({disableDefaultUI: true});
    marker.setMap(map);
};

const do_request = function(myData)
{
    if(myData.f)
    {
        document.documentElement.classList.add('w__waiting');

        return new Promise(function(resolve, reject)
        {
            const myRequest = new XMLHttpRequest();
            myRequest.onreadystatechange = () =>
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        let r = (typeof myRequest.response === 'string')
                            ? JSON.parse(myRequest.response) // fix for IE 11 that doesn't honor responseType
                            : myRequest.response;

                        if(r['ok'] === 'OK')
                        {
                            resolve(r);
                        }
                        else
                        {
                            reject(r);
                        }
                    }
                    else
                    {
                        reject({error: myRequest.status});
                    }
                }
            };

            myRequest.onerror = () =>
            {
                document.documentElement.classList.remove('w__waiting');
                reject({error: 'undefined error'});
            };

            myRequest.ontimeout = () =>
            {
                document.documentElement.classList.remove('w__waiting');
                reject({error: 'timeout'});
            };

            myRequest.open("POST", w_base + 'index.php');
            myRequest.timeout = 10000;
            myRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
            myRequest.setRequestHeader("Accept", "application/json");
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        });
    }
};

class Form
{
    constructor(parentEl)
    {
        this.form = parentEl;
        this.submitButton = this.form.querySelector('.w__form--submit');
        this.submitCheck = this.form.querySelector('input[name="isPosted"]');

        if(this.form && this.submit)
        {
            this.form.addEventListener('submit', e =>
            {
                e.preventDefault();
                if(this.submitCheck.value === "0")
                {
                    if(this.check_required())
                    {
                        this.submitCheck.value = "1";
                        this.submit();
                    }
                }
            });

            this.form.addEventListener('focus',e =>
            {
                const el = e.target,
                      parentEl = el.closest('.w__input--container')

                if(parentEl &&
                   el.classList.contains('w__input'))
                {
                    parentEl.classList.remove('w__input--error');
                }
            } ,true);
        }
        else
        {
            alert("Form or submit button missing");
        }
    }

    check_required()
    {
        let ok = true;
        const fields = this.form.querySelectorAll('input[data-required="1"],select[data-required="1"],textarea[data-required="1"]');
        for(let i=0; i<fields.length; i++)
        {
            if(this.check_value(fields[i]) === false)
            {
                const parentEl = fields[i].closest('.w__input--container');
                if(parentEl)
                {
                    parentEl.classList.add('w__input--error');
                    if(ok === true)
                    {
                        ok = false;
                    }
                }
            }
        }

        return ok;
    }

    check_value(el)
    {
        let ok;

        switch(el.type)
        {
            case 'radio':
                ok = false;
                const radios = el.closest('.w__input--radio-container').querySelectorAll('.w__input--radio[name="' + el.name + '"]');
                for(let i=0; i<radios.length; i++)
                {
                    if(radios[i].checked)
                    {
                        ok = true;
                    }
                }
                break;

            case 'checkbox':
                ok = !!el.checked;
                break;

            case 'email':
                ok = Form.valid_email(el.value.trim());
                break;

            case 'number':
                ok = ((el.min && parseInt(el.value) >= parseInt(el.min)) ||
                     (!el.min && parseInt(el.value) > 0));
                break;

            default:
                ok = !!el.value.trim();
                break;
        }

        return ok;
    }

    submit()
    {
        let el,
            data = {};
        const fields = this.form.querySelectorAll('input,select,textarea');

        for(let i=0; i<fields.length; i++)
        {
            el = fields[i];
            switch(el.type)
            {
                case 'radio':
                case 'checkbox':
                    if(el.checked)
                    {
                        data[el.name] = el.value;
                    }
                    break;

                default:
                    data[el.name] = el.value.trim();
                    break;
            }
        }

        do_request({
            f: 'form',
            action: 'submit',
            data: data
        }).then(r => {
            this.form.innerHTML = r['html'];
        }).catch(r => {
            this.form.innerHTML = r['html'];
        })
    }

    static valid_email(email)
    {
        const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
        return reg.test(email);
    };
}

class Lightbox
{
    constructor(el, type)
    {
        this.parentEl = el;
        this.lb = this.build_lightbox(type);

        switch(type)
        {
            case 'video':
                this.add_video(el.dataset.videoId);
                break;

            case 'news':
                this.load_news(el.dataset.newsId)
                break;
        }

    }

    build_lightbox()
    {
        Lightbox.fix_position();

        // remove exisiting lightbox
        if(document.getElementById('w--lightbox'))
        {
            document.getElementById('w--lightbox').remove();
        }

        const lb = document.createElement('div');
        lb.id = 'w--lightbox';
        lb.classList.add('w__lightbox');
        document.body.appendChild(lb);

        return lb;
    }

    add_video(videoId)
    {
        const videoContainer = document.createElement('div');
        videoContainer.classList.add('w__lightbox--container');
        videoContainer.classList.add('video');
        videoContainer.id = 'w--video-container';

        const videoDiv = document.createElement('div');
        videoDiv.id = 'mym-insert-here-' + videoId;
        videoContainer.appendChild(videoDiv);

        const videoScript = document.createElement('script');
        videoScript.src = 'https://www.datev-mymarketing.de/onlineMedia/code.js?ids=' + videoId;
        videoContainer.appendChild(videoScript);

        this.lb.appendChild(videoContainer);
        this.add_close(videoContainer);
        Lightbox.adjust_videoContainer();
    }

    add_close(parentEl)
    {
        const closeContainer = document.createElement('a');

        closeContainer.classList.add('w__lightbox--close');
        closeContainer.classList.add('w__js-button');
        closeContainer.dataset.f = 'close-lightbox';
        closeContainer.title = 'Video schließen';

        parentEl.appendChild(closeContainer);
    }

    load_news(newsId)
    {
        const newsContainer = document.createElement('div');
        newsContainer.id = 'w--news';
        newsContainer.classList.add('w__lightbox--container');
        newsContainer.classList.add('news');

        do_request({f: 'news', id: newsId}).then(r => {
            newsContainer.innerHTML = r['html'];
            const links = newsContainer.querySelectorAll('a');
            for(let i=0; i<links.length; i++)
            {
                links[i].setAttribute('target','_blank');
            }
            document.body.appendChild(newsContainer);
            this.add_close(newsContainer);
        }).catch(r => {
            Lightbox.close();
            console.log(r);
        })
    }

    static set_videoHeight(videoContainer)
    {
        videoContainer.offsetHeight;
        videoContainer.style.height = (get_elInfo(videoContainer)['width'] * 9 / 16).toString() + 'px';
        videoContainer.offsetHeight;
    }

    static set_videoWidth(videoContainer)
    {
        videoContainer.style.height = w_myScreen.y.toString() + 'px';
        videoContainer.style.width = (w_myScreen.y * 16 / 9).toString() + 'px';
    }

    static adjust_closePosition(closeButton)
    {
        closeButton.style = undefined;
        closeButton.offsetHeight;
        if(get_elInfo(closeButton)['top'] < 15)
        {
            closeButton.style.top = '15px';
            closeButton.style.right = '10px';
        }
    }

    static adjust_videoContainer()
    {
        const videoContainer = document.getElementById('w--video-container');
        if(videoContainer)
        {
            videoContainer.style = undefined;
            Lightbox.set_videoHeight(videoContainer);

            if(get_elInfo(videoContainer)['height'] >= w_myScreen.y)
            {
                Lightbox.set_videoWidth(videoContainer);
            }

            Lightbox.adjust_closePosition(videoContainer.querySelector('.w__lightbox--close'));
        }
    }

    static close()
    {
        const lb = document.getElementById('w--lightbox'),
              news = document.getElementById('w--news');

        if(news)
        {
            news.remove();
        }

        if(lb)
        {
            document.body.classList.remove('w__lightbox--active');
            lb.remove();
            Lightbox.release_position();
        }
    }

    static fix_position()
    {
        const scrollY = window.scrollY || window.pageYOffset;
        sessionStorage.setItem('scrollY', scrollY.toString());
        const main = document.getElementById('w--scroll-area');
        main.style.position = 'fixed';
        main.style.top = (scrollY * -1).toString() + 'px';
    }

    static release_position()
    {
        document.getElementById('w--scroll-area').removeAttribute('style');
        const scrollY = sessionStorage.getItem('scrollY');
        if(scrollY)
        {
            document.documentElement.style.scrollBehavior = 'auto';
            window.scrollTo(0, parseInt(scrollY));
            sessionStorage.removeItem('scrollY');
            document.documentElement.style.scrollBehavior = '';
        }
    }
}

class ItemSlider
{
    constructor(parentEl)
    {
        this.currentPos = 0;
        this.touchStartX = 0;
        this.touchendX = 0;

        this.slider = parentEl.querySelector('.w__item--scroll-container');
        this.content = parentEl.querySelector('.w__item--ul');
        this.slider.style.height = get_elInfo(this.content)['height'].toString() + 'px';
        this.navPrev = parentEl.querySelector('.w__item--nav.prev');
        this.navNext = parentEl.querySelector('.w__item--nav.next');
        if(get_elInfo(this.content)['width'] < get_elInfo(this.slider).width)
        {
            this.navNext.classList.add('inactive');
        }
        this.slider.classList.add('active');
        this.add_events(parentEl);
    }

    add_events(parentEl)
    {
        parentEl.addEventListener('click', e =>
        {
            const el = e.target;
            if(el.classList.contains('w__item--nav'))
            {
                this.move_slider(el.classList.contains('prev') ? 1 : -1);
            }
        });

        if(w_pointer['down'])
        {
            this.slider.style.touchAction = 'pan-y';
            this.slider.addEventListener(w_pointer['down'], e => { this.touchStart(e) });
            this.slider.addEventListener(w_pointer['move'], this.touchMove.bind(this));
            this.slider.addEventListener(w_pointer['up'], this.touchEnd.bind(this));
        }
    }

    touchStart(e)
    {
        if(!w_pointer['checkType'] || e.pointerType === 'touch')
        {
            this.touchStartX = e.pageX ? e.pageX : e.page.x;
            this.touchEndX = this.touchStartX;
        }
    }

    touchMove(e)
    {
        if(!w_pointer['checkType'] || e.pointerType === 'touch')
        {
            this.touchEndX = e.pageX ? e.pageX : e.page.x;
        }
    }

    touchEnd(e)
    {
        if(!w_pointer['checkType'] || e.pointerType === 'touch')
        {
            if(this.touchStartX - this.touchEndX < -75)// && this.sliding === false)
            {
                this.move_slider(1);
            }
            else if(this.touchStartX - this.touchEndX > 75)// && this.sliding === false)
            {
                this.move_slider(-1);
            }
        }
    }

    move_slider(direction)
    {
        if(get_elInfo(this.slider).width < get_elInfo(this.content)['width'])
        {
            let slideAmount = 640 * direction,
                rightMax = (get_elInfo(this.content)['width'] - get_elInfo(this.slider).width) * -1;

            if(w_myScreen.layout === 'tablet')
            {
                slideAmount = 440 * direction;
            }
            else if(w_myScreen.layout === 'smartphone')
            {
                slideAmount = get_elInfo(this.slider).width * direction;
            }

            this.currentPos += slideAmount;

            this.navPrev.classList.remove('inactive');
            this.navNext.classList.remove('inactive');

            if(this.currentPos >= -20)
            {
                this.currentPos = 0;
                this.navPrev.classList.add('inactive');
            }
            else if(this.currentPos <= (rightMax + 20))
            {
                this.currentPos = rightMax;
                this.navNext.classList.add('inactive');
            }

            this.content.style.transform = 'translateX(' + Math.round(this.currentPos).toString() + 'px)';
        }
    }

    get_sliderLength()
    {
        const data = get_elInfo(this.slider);
        return data.right;
    }
}

class Slideshow
{
    constructor(parentEl)
    {
        this.landscape = parentEl.classList.contains('landscape');
        this.interval = parentEl.classList.contains('w__header') ? 10000 : 6000;
        this.slides = parentEl.querySelectorAll('.w__slider--item');
        if(this.slides.length > 1)
        {
            this.activeSlideNo = 0;
            setTimeout(() =>
            {
                this.next();
            }, this.interval - w_duration['long'])
        }
    }

    next()
    {
        let nextSlideNo = this.activeSlideNo + 1;

        if(nextSlideNo >= this.slides.length)
        {
            nextSlideNo = 0;
        }

        const lazyImage = this.slides[nextSlideNo];

        if(lazyImage.classList.contains('load'))
        {
            lazyImage.classList.remove('load');
            this.load(lazyImage.querySelector('.w__slider--image'), nextSlideNo);
        }
        else
        {
            this.change(nextSlideNo);
        }
    }

    load(loadEl, nextSlideNo)
    {
        const newImage = new Image();
        newImage.src = adjust_imagePath(loadEl.href,
                                        this.slides[nextSlideNo].getBoundingClientRect()['width'],
                                        this.slides[nextSlideNo].getBoundingClientRect()['height'],
                                        this.landscape);
        newImage.alt = loadEl.dataset.alt;
        newImage.className = 'w__slider--image';
        newImage.addEventListener('load',() =>
        {
            loadEl.insertAdjacentElement('afterend', newImage);
            loadEl.remove();
            newImage.offsetHeight;
            this.change(nextSlideNo);
        });
    }

    change(nextSlideNo)
    {
        this.slides[this.activeSlideNo].classList.remove('active');
        this.slides[nextSlideNo].classList.add('active');
        this.activeSlideNo = nextSlideNo;
        setTimeout(() => {
            this.next();
        }, this.interval)
    }
}

const adjust_imagePath = function(imgSrc, sizeX, sizeY, landscape)
{
    let targetPath;
    sizeX *= w_myScreen.highDpi;
    if(imgSrc.match(/\/header\//))
    {
        if(w_myScreen.layout === 'desktop')
        {
            if(sizeX <= 640)
            {
                targetPath = '640x320';
            }
            else if(sizeX <= 920)
            {
                targetPath = '920x460';
            }
            else if(sizeX <= 1280)
            {
                targetPath = '1280x640';
            }
            else if(sizeX <= 1600)
            {
                targetPath = '1600x800';
            }
            else if(sizeX <= 1920)
            {
                targetPath = '1920x960';
            }
            else
            {
                targetPath = '2560x1280';
            }
        }
        else
        {
            if(sizeX <= 375)
            {
                targetPath = '375x400';
            }
            else if(sizeX <= 630)
            {
                targetPath = '630x672';
            }
            else if(sizeX <= 900)
            {
                targetPath = '900x960';
            }
            else
            {
                targetPath = '1200x1280';
            }
        }
        imgSrc = imgSrc.replace('/header/1920x960/', '/header/' + targetPath + '/');
    }
    else
    {
        if(w_myScreen.layout === 'desktop' || landscape === true)
        {
            sizeY *= w_myScreen.highDpi;
            if(sizeY <= 400)
            {
                targetPath = 'h400';
            }
            else if(sizeY <= 600)
            {
                targetPath = 'h600';
            }
            else
            {
                targetPath = 'h800';
            }
        }
        else
        {
            if(sizeX <= 375)
            {
                targetPath = '375x400';
            }
            else if(sizeX <= 630)
            {
                targetPath = '630x672';
            }
            else if(sizeX <= 900)
            {
                targetPath = '900x960';
            }
            else
            {
                targetPath = '1200x1280';
            }
        }
        imgSrc = imgSrc.replace('/text/h600/', '/text/' + targetPath + '/');
    }

    return imgSrc;
};

/**
 * analyze browser engine, os and mobile
 */
const get_browser = function()
{
    w_myBrowser.mobile = false;

    if(navigator.vendor && navigator.vendor.match(/google/i))
    {
        w_myBrowser.engine = 'blink';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.vendor && navigator.vendor.match(/apple/i))
    {
        w_myBrowser.engine = 'webkit';
        w_myBrowser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9][0-9]*(\.[1-9])?).*/i,'$1'));
    }
    else if(navigator.userAgent.match(/firefox\//i))
    {
        w_myBrowser.engine = 'gecko';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/edge\//i))
    {
        w_myBrowser.engine = 'edgehtml';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/trident\//i))
    {
        w_myBrowser.engine = 'trident';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9][0-9]*)\..*/i,'$1')) + 4;
    }

    switch(navigator.platform.toLowerCase())
    {
        case 'win32':
            w_myBrowser.os = 'windows';
            break;

        case 'macintel':
            // detect iOS on iPadOS/Safari 13
            if(navigator.maxTouchPoints > 1)
            {
                w_myBrowser.os = 'ios';
                w_myBrowser.mobile = true;
            }
            else
            {
                w_myBrowser.os = 'osx';
            }
            break;

        case 'ipad':
        case 'iphone':
            w_myBrowser.os = 'ios';
            w_myBrowser.mobile = true;
            break;

        default:
            if(navigator.userAgent.match(/android/i))
            {
                w_myBrowser.os = 'android';
                w_myBrowser.mobile = true;
            }
            else if(navigator.platform.match(/linux/i))
            {
                w_myBrowser.os = 'linux';
            }
    }
};

/**
 * returns element dimensions and positions
 *
 * @param el
 * @returns {ClientRect | DOMRect}

 const get_elementInfo = function(el)
 {
    return el.getBoundingClientRect(document.body);
};
 */

/**
 * Measures and stores various screen parameters
 */
const get_screenSize = function()
{
    // pixel density
    w_myScreen.highDpi = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if(w_myScreen.highDpi > 2)
    {
        w_myScreen.highDpi = 2;
    }

    // screen size
    if(w_myBrowser.mobile === true)
    {
        w_myScreen.x = window.innerWidth;
        w_myScreen.y = window.innerHeight;
    }
    else
    {
        w_myScreen.x = document.body.clientWidth;
        w_myScreen.y = window.innerHeight;
    }

    if(window.matchMedia('(max-width: 600px)').matches)
    {
        w_myScreen.layout = 'smartphone';
    }
    else if(window.matchMedia('(max-width: 900px)').matches)
    {
        w_myScreen.layout = 'tablet';
    }
    else
    {
        w_myScreen.layout = 'desktop';
    }

    Lightbox.adjust_videoContainer();
};

const add_interactionObserver = function()
{
    if(w_myScreen.layout === 'desktop')
    {
        const options = {
                root: null,
                rootMargin: "-150px 0px",
                threshold: .2
              },
              observer = new IntersectionObserver(do_observerInteraction, options),
              targets = document.querySelectorAll('.w__anchor');
        for(let i=0; i<targets.length; i++)
        {
            observer.observe(targets[i].closest('.w__module--container,.w__module--googlemap'));
        }
    }
};

const do_observerInteraction = function(entries)
{
    const links = document.getElementById('w--menu').querySelectorAll('li');

    if(this.map === undefined)
    {
        this.map = false;
    }

    entries.forEach(entry =>
    {
        const myTarget = entry.target.querySelector('.w__anchor');
        if(entry.isIntersecting === true)
        {
            if(myTarget.id === 'map')
            {
                this.map = true;
                const currentLink = document.getElementById('w--menu')
                    .querySelector('li.active');
                if(currentLink)
                {
                    currentLink.classList.remove('active');
                }
                links[(links.length - 1)].classList.add('active');
            }
            else
            {
                for(let i = 0; i < links.length; i++)
                {
                    if(myTarget.id === links[i].dataset.anchor)
                    {
                        links[i].classList.add('active');
                    }
                    else
                    {
                        links[i].classList.remove('active');
                    }
                }
            }
        }
        else
        {
            if(myTarget.id === 'map')
            {
                this.map = false;
            }
            else
            {
                let myLink = document.getElementById('w--menu')
                    .querySelector('li[data-anchor="' + myTarget.id + '"]');
                if(myLink)
                {
                    myLink.classList.remove('active');
                }
            }
        }
    });
};

const get_elInfo = function(el)
{
    return el.getBoundingClientRect(document.body);
};

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(w_resizeTimer);
    w_resizeTimer = requestAnimationFrame(get_screenSize);
});